export const actionTypes = {
  GET_CROPS_START: "CROPS/GET_CROPS_START",
  GET_CROPS: "CROPS/GET_CROPS",
  GET_CROPS_FAIL: "CROPS/GET_CROPS_FAIL",

  GET_VARIETIES_START: "CROPS/GET_VARIETIES_START",
  GET_VARIETIES: "CROPS/GET_VARIETIES",
  GET_VARIETIES_FAIL: "CROPS/GET_VARIETIES_FAIL"
};
